import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { TextField, Modal, Button, Animation } from 'components';
import { FaTimes } from 'react-icons/fa';
import OptionBlock from './OptionBlock'
import GoogleModal from './GoogleModal'
import { AnimatePresence } from 'framer-motion'

import { clientContext } from 'context';
import * as actionCreators from 'store/actions';
import * as api from 'api';
import { genAuthURL } from 'utils';

const Container = styled.div`
    border-radius: 5px;
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    width: 30rem;
    max-width: 90vw;
`

const TextContainer = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    padding: 0.5rem;
`

const OptionsContainer = styled.div`
    border: 1px solid var(--primary-accent-color);
    border-radius: 5px;
    margin: 0.5rem 0 0 0;
    padding: 0.5rem;
    overflow-y: auto;
    max-height: 15rem;
    background-color: var(--primary-color);
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`

const Title = styled.div`
    font-weight: bold;
`

const AppSelector = props => {
    const {
        options
    } = props;
    const [text, setText] = React.useState(null);
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const uid = user['uid']
    // dispatch(actionCreators.updateWorkflow(updatedWorkflow, workflows, user['uid']))

    const getOptions = () => {
        let blocks = Object.values(clientContext).map(client => {
            if(!client['active']){ return }
            if(options && !options.include(client['value'])){ return }
            
            let block
            if(['GOOGLE_CALENDAR','GSHEET'].includes(client['value'])){
                block = <OptionBlock title={client['title']} icon={client['icon']}
                            onSelect={() => dispatch(actionCreators.setModal(<GoogleModal client={client['value']}/>))} 
                            />
            } else {
                block = <OptionBlock title={client['title']} icon={client['icon']}
                                onSelect={() => genAuthURL(client['value'].toUpperCase(), uid)} 
                                // google={['GOOGLE_CALENDAR','GSHEET'].includes(client['value'])}
                                />
            }
            
            if(text){
                if(client['title'].toLowerCase().includes(text)){
                    return block
                }
            } else {
                return block
            }
        })
        return blocks
    }

    return (
        <Modal>
            <Container>
                <Header>
                    <Title>Connect a new app</Title>
                    <Button icon={<FaTimes/>} onSelect={() => dispatch(actionCreators.setModal(null,null))}
                        styles={{backgroundColor:'var(--secondary-color)', margin: 0, padding: '0.5rem', boxShadowColor: 'transparent'}}/>
                </Header>

                <TextContainer>
                    <TextField value={text} onChange={(e) => setText(e.target.value)} placeholder='Search for an app' autoFocus mantainFocus/>
                </TextContainer>

                <AnimatePresence>
                    <OptionsContainer>
                        <Animation animation='expand'>{getOptions()}</Animation>
                    </OptionsContainer>
                </AnimatePresence>
            </Container>
        </Modal>
    )
}

export default AppSelector